import { FaCalendarDays, FaComments, FaClipboardList } from "react-icons/fa6";

const About = {
    sub: "THE ROBOTIC GAMES FOR EVERYONE ",
    heading: "Fostering Knowledge with Science, Technology, and Education through WRG® Robot Games.",
    description:[
        "The year 2025 is an exciting one, marking a new chapter in the development of our robotics technology with the maturation of edge AI computing. Starting this year, we anticipate the integration of more edge AI capabilities and novel robotics innovations into the WRG competitions. 2025 truly marks the inaugural year of AI Robotic technology.\n\n",
        "As the capabilities of edge AI computing improve, robots can achieve greater perception and control. With the deployment of localized large language models, robots can now perform exceptionally well even without relying on cloud-based AI, operating effectively in offline scenarios to complete more complex tasks. What was once a dreamlike vision of AI robotics is now becoming a reality, step by step.",
        "In the 2025 competition, we are using AI Robotic as a blueprint to illustrate our vision of the future. At WRG, we have designed innovative competition categories that combine physical robots with firmware, software, and various AI technologies to create smarter and more agile robotic systems. These systems will engage in a wide range of creative applications, presenting a vision of a brighter future."
    ],
    points: [
        // { icon: <FaCalendarDays />, title: "Networking Opportunities" },
        // { icon: <FaComments />, title: "Expert Speakers" },
        // { icon: <FaCalendarDays />, title: "Regular Meetups" },
        // { icon: <FaClipboardList />, title: "Resource Sharing" }
    ],
    button: {
        text: "Registration",
        link: "Registration"
    }
};

export default About;